import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ResponseError } from '../../types/error';

@Injectable()
export class ErrorService {
  error$ = new BehaviorSubject<ResponseError>(null);
}
